import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import { WebsiteCards } from '../../templates';

/**
 * The hero section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class WebsiteCardsView extends Component {

	render () {
		const { websiteCards } = this.props.content.hubLandingPage;

		return (
			<WebsiteCards websiteCards={websiteCards} />
		);
	}

}

export default withLanguageContext(WebsiteCardsView);



// WEBPACK FOOTER //
// ./src/components/views/WebsiteCardsView/WebsiteCardsView.js